import { RGBColor } from 'react-color';

import tinycolor from 'tinycolor2';

export type ProjectLayoutDto = {
  questionTextColor: string;
  backgroundColor: string;
  navigationAndProgressColor: string;
  saveContinueColor: string;
};

export type ProjectLayoutModel = {
  questionTextColor: RGBColor;
  backgroundColor: RGBColor;
  navigationAndProgressColor: RGBColor;
  saveContinueColor: RGBColor;
};

export function mapProjectLayoutModelToDto(model: ProjectLayoutModel): ProjectLayoutDto {
  return {
    questionTextColor: tinycolor(model.questionTextColor).toHexString(),
    backgroundColor: tinycolor(model.backgroundColor).toHexString(),
    navigationAndProgressColor: tinycolor(model.navigationAndProgressColor).toHexString(),
    saveContinueColor: tinycolor(model.saveContinueColor).toHexString(),
  };
}

export function mapProjectLayoutDtoToModel(dto: ProjectLayoutDto): ProjectLayoutModel {
  return {
    questionTextColor: tinycolor(dto.questionTextColor).toRgb(),
    backgroundColor: tinycolor(dto.backgroundColor).toRgb(),
    navigationAndProgressColor: tinycolor(dto.navigationAndProgressColor).toRgb(),
    saveContinueColor: tinycolor(dto.saveContinueColor).toRgb(),
  };
}
